module.exports = __webpack_public_path__ + "img/calendar-month.37429eff.svg";